import { gql } from '@ori/fetching';
import { BASE_PRODUCT_FRAGMENT } from '@ori/product-box';

export const favoriteProductsQuery = gql`
  ${BASE_PRODUCT_FRAGMENT}
  query GetFavoriteProducts($productCodes: [ID!]) {
    products(productCodes: $productCodes) {
      ...BaseProduct
    }
  }
`;
